<template>
  <v-dialog v-model="internalDialogVisible"
            width="600px">
    <v-card>
      <v-card-title class="headline">Manage Seat Change Request <v-spacer /><v-btn icon @click="close()"><v-icon>clear</v-icon></v-btn></v-card-title>
      <v-card-text>
        <v-container>
          <v-row style="font-weight: bold;">User to be deleted:</v-row>
          <v-row>First and Last Name: <span style="font-weight: bold"> {{ pendingSeatRequest.firstName }} {{ pendingSeatRequest.lastName }}</span></v-row>
          <v-row>User Email: <span style="font-weight: bold"> {{ pendingSeatRequest.email }}</span></v-row>
          <v-row justify="start">
            <v-col cols="auto" class="py-0 px-0">
              <v-checkbox v-model="deleteUser" hide-details />
            </v-col>
            <v-col cols="auto" class="pt-5 pb-0">
              <span class="font-italic">To <span style="font-weight: bold">cancel</span> this pending request, check this box then update request</span>
            </v-col>
          </v-row>
          <v-row>
            <v-alert v-model="showDeleteError" width="576px" type="error" dense outlined prominent dismissible>Error sending seat change addition request, please try again or contact customer support.</v-alert>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="pl-5">
        <v-btn depressed tile color="#004C97" class="text-uppercase white--text" :disabled="!valid || disableSubmit" @click="submit()">Update Request</v-btn>
        <v-btn depressed tile @click="close()">Cancel</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'RemoteAgencyPendingUserDeleteDialog',
  props: {
    showDeleteUserDialog: Boolean,
    id: { required: true, type: Number }
  },
  data () {
    return {
      valid: true,
      showDeleteError: false,
      disableSubmit: false,
      deleteUser: false
    };
  },
  computed: {
    ...mapState(['agency', 'agencyUser']),
    ...mapGetters(['getPendingSeatManagementRequestById']),
    internalDialogVisible: {
      get: function () {
        return this.showDeleteUserDialog;
      },
      set: function (visible) {
        if (!visible) {
          this.$emit('close');
        }
      }
    },
    pendingSeatRequest () {
      return this.getPendingSeatManagementRequestById(this.id);
    }
  },
  methods: {
    ...mapActions(['deletePendingSeatManagementRequest']),
    close: function () {
      this.internalDialogVisible = false;
    },
    async submit () {
      if (!this.deleteUser) {
        return;
      }
      this.disableSubmit = true;
      var response = await this.$api.deleteAgencySeatRequest(this.pendingSeatRequest.id);
      if (response.code !== 0 && response.code !== 2) {
        this.showDeleteError = true;
        this.disableSubmit = false;
        return;
      }
      this.deletePendingSeatManagementRequest({ id: this.pendingSeatRequest.id, action: 'remove', seat: { FirstName: this.pendingSeatRequest.firstName, LastName: this.pendingSeatRequest.lastName, Email: this.pendingSeatRequest.email } });
      this.$emit('success');
      this.disableSubmit = false;
      this.close();
    }
  }
};
</script>

<style scoped>

</style>
